import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { HomePage } from '../home/home';
import { ContactPage } from '../contact/contact';
import { TabsPage } from '../tabs/tabs';
import { settingsPage } from '../settings/settings';
import {groupsPage} from '../groups/groupsPage';
import {personPage} from '../person/person';
import {joinGroupPage} from '../../pages/groups/joinGroup/joinGroupPage';
import {FirebaseStorageProvider } from "../../providers/firebase-storage-provider"
import {MyDashboardPage} from '../../pages/dashboard/my-dashboard/my-dashboard';
import { AddLogPage} from "../add-log/add-log";
import {ShowActivityLogsPage } from '../show-activity-logs/show-activity-logs'
import {groupProfilePage } from '../groupProfile/group-profile.page'
import {TimelinePage} from "../Timeline/Timeline";
import {Inject, ViewChild} from '@angular/core';
import {   Nav } from 'ionic-angular';
@Component({
    selector: 'mynav',
    templateUrl: 'nav.html'
})
export class NavPage {
    @ViewChild(Nav) nav;

    rootPage: any = MyDashboardPage; 
    constructor(
        private fsp: FirebaseStorageProvider        
        
    ) {

    }
    gotoPage(page) {
        switch (page) { 
            case 'Timeline':
                this.rootPage = TimelinePage;
                break;
            case 'myDashBoard':
                this.rootPage = MyDashboardPage;
                break;         
            case 'AddLog':
                this.rootPage = AddLogPage;
                break;   
            case 'userProfile':                
                this.nav.push(personPage);
                break;            
            case 'activityLogs':
                this.rootPage = ShowActivityLogsPage;
                break;
            case 'groupProfile':
                this.rootPage = groupProfilePage;
                break;
            default:
                console.log("Error.......");                       
        }
    }
    uploadData() {
        this.fsp.ngUpLoad();
    }
}



// WEBPACK FOOTER //
// ./src/pages/nav/nav.ts